module.exports = __webpack_public_path__ + "img/ibeacon_marker.png?bb1ad1391a6282603cecf69fe5297e57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ibeacon_marker.png
// module id = 1373
// module chunks = 1